import { Toaster } from 'react-hot-toast';
import { AppRouter } from './router';
import type {} from './global.d.ts';
import { ThirdPartyScripts } from './components/Common/index.ts';
import CombinedProvider from './context/CombinedProvider.tsx';
import { enableMapSet } from 'immer';
import { useEffect } from 'react';
import useWebVitals from './hooks/useWebVitals.ts';

enableMapSet();

function App() {
  useEffect(() => {
    document.getElementById('initial-loader')?.remove();
  }, []);

  useWebVitals();

  return (
    <>
      <ThirdPartyScripts />
      <CombinedProvider>
        <AppRouter />
      </CombinedProvider>
      <Toaster
        position="bottom-center"
        toastOptions={{
          className: '!bg-gray-600 !text-white',
        }}
      />
    </>
  );
}

export default App;
